// extracted by mini-css-extract-plugin
export var box = "_4b-2";
export var checkboxControl = "_4b-0";
export var checkboxRow = "_4b-a";
export var checked = "_4b-3";
export var descriptionSpacer = "_4b-c";
export var disabled = "_4b-4";
export var icon = "_4b-8";
export var input = "_4b-1";
export var labelSpacer = "_4b-b";
export var large = "_4b-7";
export var medium = "_4b-6";
export var small = "_4b-5";
export var text = "_4b-9";